module.exports = __webpack_public_path__ + "static/img/tourimg-2.c893de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/tourimg-2.png
// module id = hy3A
// module chunks = 1